/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetAllCountriesQueryResponse } from '../../types/TelegramGeoControllerGetAllCountries.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetAllCountries } from '../../methods/telegramGeoGetAllCountries.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetAllCountriesQueryKey = () => [{ url: '/api/telegram/geo/countries/all' }] as const;

export type TelegramGeoGetAllCountriesQueryKey = ReturnType<typeof telegramGeoGetAllCountriesQueryKey>;

export function telegramGeoGetAllCountriesQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetAllCountriesQueryKey();
  return queryOptions<
    TelegramGeoControllerGetAllCountriesQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetAllCountriesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetAllCountries(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/countries/all}
 */
export function useTelegramGeoGetAllCountries<
  TData = TelegramGeoControllerGetAllCountriesQueryResponse,
  TQueryData = TelegramGeoControllerGetAllCountriesQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetAllCountriesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetAllCountriesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetAllCountriesQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetAllCountriesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
